export const inputsNameFormEnum = {
  cuiaba: 'tanker_truck',
  rio_de_janeiro: 'tanker_truck_rj',
};
